const Close = "assets/close.svg";
export { Close };
